import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useCallback, useState } from "react";
import classnames from "classnames";
import { GenericConfigContext } from "/contexts/generic-config-context";
import { StyledPeriodSelect } from "./period-select-component.scss";
import { getCurrencyName } from "services/pricing-service";
export const PeriodSelect = ({ onPeriodChange, primaryColor, isHomepagePricing, crossedPricingUI, useClassicCardChrome })=>{
    const [period, setPeriod] = useState("yearly");
    const { translate, currency: currencyFromContext, forceCurrency, cloudfrontViewerCountry } = useContext(GenericConfigContext);
    const currency = currencyFromContext || getCurrencyName({
        forceCurrency,
        countryCode: cloudfrontViewerCountry
    });
    const isCurrencySupportPriceIncrease = [
        "usd",
        "eur",
        "euro"
    ].includes(currency);
    const handlePeriodChange = useCallback((newPeriod)=>{
        setPeriod(newPeriod);
        onPeriodChange(newPeriod);
    }, [
        onPeriodChange
    ]);
    return /*#__PURE__*/ _jsxs(StyledPeriodSelect, {
        className: "periodSelect",
        style: {
            "--primary-color": primaryColor
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: classnames("period", {
                    selected: period === "yearly",
                    "is-homepage-pricing": isHomepagePricing,
                    "crm-classic": useClassicCardChrome
                }),
                onClick: ()=>{
                    handlePeriodChange("yearly");
                },
                children: [
                    translate("pricingPage.periods.yearly.displayNameShort"),
                    " ",
                    crossedPricingUI && isCurrencySupportPriceIncrease ? translate("pricingPage.periods.saveCRMNew") : translate("pricingPage.periods.save")
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: "|"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: classnames("period", {
                    selected: period === "monthly",
                    "is-homepage-pricing": isHomepagePricing,
                    "crm-classic": useClassicCardChrome
                }),
                onClick: ()=>{
                    handlePeriodChange("monthly");
                },
                children: translate("pricingPage.periods.monthly.displayName")
            })
        ]
    });
};
